import React, { Fragment, useState } from "react";
import {
  Grid,
  Button,
  Dialog,
  DialogContent,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  dialog: {
    maxWidth: "1100px",
  },
  banner: {
    width: "100%",
    height: "auto",
    display: "block",
  },
  button: {
    textAlign: "center",
  },
}));

const MsmWelcome = () => {
  const classes = useStyles();

  const [openMsm, setOpenMsm] = useState(true);

  const handleCloseMsm = () => {
    setOpenMsm(false);
  };

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth={false}
        classes={{ paper: classes.dialog }}
        open={openMsm}
        onClose={handleCloseMsm}
      >
        <DialogContent>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={12}>
              <img
                src="https://facturarpro.s3.us-east-2.amazonaws.com/portadapanama.png"
                alt="Facturadas"
                className={classes.banner}
              />
            </Grid>

            <Grid item xs={12} className={classes.button}>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleCloseMsm}
              >
                Aceptar
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
};

export default MsmWelcome;
